export default __webpack_public_path__ + "static/media/a037-student-t3-4.c75b280e.svg";